// extracted by mini-css-extract-plugin
export default {"container":"ValuationSettings_container__SxMta","modal":"ValuationSettings_modal__22Hc2","comment":"ValuationSettings_comment__P+wS+","button":"ValuationSettings_button__-WdpE"};